(function () {
  /**
   * Unpublished Vehicle Finder map (1 Sep 2026).
   * Canonical collection first. 0-product vehicles already point at make TC.
   * Never land on *-2 / *-3 duplicate handles.
   */
  var MAKE_TC = {
    Toyota: '/collections/throttle-controllers-toyota',
    Ford: '/collections/throttle-controllers-ford',
    Nissan: '/collections/throttle-controllers-nissan',
    Mitsubishi: '/collections/throttle-controllers-mitsubishi',
    Isuzu: '/collections/throttle-controllers-isuzu',
    Mazda: '/collections/throttle-controllers-mazda',
    Jeep: '/collections/throttle-controllers-jeep',
    Volkswagen: '/collections/throttle-controllers-volkswagen',
    Holden: '/collections/throttle-controllers-holden',
    'Land Rover': '/collections/throttle-controllers-land-rover',
    Suzuki: '/collections/throttle-controllers-suzuki',
    Chevrolet: '/collections/throttle-controllers-chevrolet',
    Lexus: '/collections/throttle-controllers-lexus'
  };

  var FALLBACK = {
    'toyota-prado-250': MAKE_TC.Toyota,
    'toyota-landcruiser-300-series': MAKE_TC.Toyota,
    'ford-ranger-pk': MAKE_TC.Ford,
    'ford-everest-next': MAKE_TC.Ford,
    'ford-everest-ua': MAKE_TC.Ford,
    'nissan-navara-np300': MAKE_TC.Nissan,
    'nissan-patrol-y62': MAKE_TC.Nissan,
    'nissan-patrol-y61-gu': MAKE_TC.Nissan,
    'nissan-pathfinder-r52': MAKE_TC.Nissan,
    'volkswagen-amarok': MAKE_TC.Volkswagen,
    'gwm-cannon-alpha': '/collections/throttle-controllers',
    'jeep-wrangler-jk': MAKE_TC.Jeep,
    'holden-colorado-rc': MAKE_TC.Holden
  };

  var CANONICAL = {
    'Toyota|Hilux N80': '/collections/toyota-hilux-n80',
    'Toyota|Hilux N70': '/collections/toyota-hilux-n70',
    'Toyota|Prado J150': '/collections/toyota-prado-150',
    'Toyota|Prado 150': '/collections/toyota-prado-150',
    'Toyota|Prado J120': '/collections/toyota-prado-120',
    'Toyota|Prado 120': '/collections/toyota-prado-120',
    'Toyota|Prado 250': FALLBACK['toyota-prado-250'],
    'Toyota|LandCruiser 200': '/collections/toyota-landcruiser-200-series',
    'Toyota|LandCruiser 300': FALLBACK['toyota-landcruiser-300-series'],
    'Toyota|LandCruiser 70 Series': '/collections/toyota-landcruiser-79-series',
    'Toyota|FJ Cruiser': '/collections/toyota-fj-cruiser',
    'Toyota|Fortuner': '/collections/toyota-fortuner',
    'Toyota|AN50': '/collections/toyota-fortuner',
    'Toyota|AN150': '/collections/toyota-fortuner',
    'Ford|Ranger PX1': '/collections/ford-ranger-pxi',
    'Ford|Ranger PX2': '/collections/ford-ranger-pxii',
    'Ford|Ranger PX3': '/collections/ford-ranger-pxiii',
    'Ford|PX3/PX4': '/collections/ford-ranger-pxiii',
    'Ford|Ranger Next Gen': '/collections/ford-ranger',
    'Ford|NextGen T6': '/collections/ford-ranger',
    'Ford|Ranger PK': FALLBACK['ford-ranger-pk'],
    'Ford|Raptor': '/collections/ford-raptor',
    'Ford|Ranger Raptor': '/collections/ford-raptor-pxiii',
    'Ford|Everest Next Gen': FALLBACK['ford-everest-next'],
    'Ford|Everest UA': FALLBACK['ford-everest-ua'],
    'Mitsubishi|Triton MV': '/collections/mitsubishi-triton-mv',
    'Mitsubishi|Triton MQ/MR': '/collections/mitsubishi-triton-mq',
    'Mitsubishi|Triton': '/collections/mitsubishi-triton-mq',
    'Mitsubishi|Triton ML/MN': '/collections/mitsubishi-triton-ml',
    'Isuzu|D-Max RG': '/collections/isuzu-d-max-rg',
    'Isuzu|D-Max': '/collections/isuzu-d-max-rg',
    'Isuzu|D-Max TF': '/collections/isuzu-d-max-tf',
    'Isuzu|D-Max RC': '/collections/isuzu-d-max-rc',
    'Isuzu|MU-X RJ': '/collections/isuzu-mu-x-rj',
    'Isuzu|MU-X RF': '/collections/isuzu-mu-x-rf',
    'Isuzu|MUX': '/collections/isuzu-mux-uj',
    'Mazda|BT-50 TF': '/collections/mazda-bt-50-tf',
    'Mazda|BT-50 UN': '/collections/mazda-bt-50-un',
    'Mazda|BT-50': '/collections/mazda-bt-50',
    'Nissan|Navara NP300': FALLBACK['nissan-navara-np300'],
    'Nissan|Navara D40': '/collections/nissan-navara-d40',
    'Nissan|Patrol Y62': FALLBACK['nissan-patrol-y62'],
    'Nissan|Patrol Y61 GU': FALLBACK['nissan-patrol-y61-gu'],
    'Nissan|Pathfinder R51': '/collections/nissan-pathfinder-r51',
    'Nissan|Pathfinder R52': FALLBACK['nissan-pathfinder-r52'],
    'Suzuki|Jimny': '/collections/suzuki-jimny-jb74',
    'Suzuki|Jimny SN413': '/collections/suzuki-jimny-sn413',
    'Volkswagen|Amarok NF': '/collections/volkswagen-amarok-nf',
    'Volkswagen|Amarok': FALLBACK['volkswagen-amarok'],
    'Volkswagen|Amarok 2H': FALLBACK['volkswagen-amarok'],
    'GWM|Cannon': '/collections/gwm-cannon-npw',
    'GWM|Cannon Alpha': FALLBACK['gwm-cannon-alpha'],
    'GWM|Tank 300': '/collections/gwm-tank-300',
    'Jeep|Wrangler JL': '/collections/jeep-wrangler',
    'Jeep|Wrangler JK': FALLBACK['jeep-wrangler-jk'],
    'Jeep|Gladiator JT': '/collections/jeep-gladiator-jt',
    'Jeep|Grand Cherokee WL': '/collections/jeep-grand-cherokee-wl',
    'LDV|T60': '/collections/ldv-t60',
    'Holden|RG Colorado': '/collections/holden-colorado-rg',
    'Holden|Colorado RC': FALLBACK['holden-colorado-rc']
  };

  // 13 Oct 2026: every active TC reachable (direct product links for vehicles without a model collection)
  var EXTRA = {
"Volkswagen|Golf (1997–2003)": "/products/throttle-controller-volkswagen-golf-1997-2003",
"Holden|MALIBU (2008–2016)": "/products/throttle-controller-holden-malibu-2008-2016",
"Toyota|Rukus (2007–2015)": "/products/throttle-controller-toyota-rukus-2007-2015",
"Lexus|RX AL10 (2012–2015)": "/products/throttle-controller-lexus-rx-al10-2012-2015",
"Lexus|RX AL10 (2009–2012)": "/products/throttle-controller-lexus-rx-al10-2009-2012",
"Lexus|RX XU30 (2004–2009)": "/products/throttle-controller-lexus-rx-xu30-2004-2009",
"Lexus|RX AL20 (2019–2022)": "/products/throttle-controller-lexus-rx-al20-2019-2022",
"Lexus|RC XC10 (2018 onwards)": "/products/throttle-controller-lexus-rc-xc10-2018-onwards",
"Lexus|RC XC10 (2014–2018)": "/products/throttle-controller-lexus-rc-xc10-2014-2018",
"Lexus|NX AZ10 (2014–2017)": "/products/throttle-controller-lexus-nx-az10-2014-2017",
"Lexus|LS XF40 (2013–2017)": "/products/throttle-controller-lexus-ls-xf40-2013-2017",
"Lexus|IS XE30 (2021 onwards)": "/products/throttle-controller-lexus-is-xe30-2021-onwards",
"Lexus|IS XE30 (2013–2016)": "/products/throttle-controller-lexus-is-xe30-2013-2016",
"Lexus|IS (2016–2020)": "/products/throttle-controller-lexus-is-2016-2020",
"Toyota|Yaris XP90 (2005–2008)": "/products/throttle-controller-toyota-yaris-xp90-2005-2008",
"Toyota|Yaris XP90 Series II (2008–2011)": "/products/throttle-controller-toyota-yaris-xp90-2008-2011",
"Toyota|Kluger (2000-2007)": "/products/roar-4x4-throttle-controller-toyota-kluger-2000",
"Lexus|GS L10 (2016–2020)": "/products/throttle-controller-lexus-gs-l10-2016-2020",
"Lexus|GS L10 (2012–2015)": "/products/throttle-controller-lexus-gs-l10-2012-2015",
"Lexus|CT200h ZWA10 (2018–2021)": "/products/throttle-controller-lexus-ct200h-zwa10-2018-2021",
"Volkswagen|Jetta A5 (2006–2011)": "/products/throttle-controller-volkswagen-jetta-a5-2006-2011",
"Lexus|CT200h ZWA10 (2014–2017)": "/products/throttle-controller-lexus-ct200h-zwa10-2014-2017",
"Nissan|Almera (2000 onwards)": "/products/throttle-controller-nissan-almera-2000-onwards",
"Suzuki|LIANA (2005 onwards)": "/products/throttle-controller-suzuki-liana-2005-onwards",
"Nissan|Altima (2006 onwards)": "/products/throttle-controller-nissan-altima-2006-onwards",
"Skoda|Fabia (1999–2014)": "/products/throttle-controller-skoda-fabia-1999-2014",
"Audi|TT Mk1 (1998–2006)": "/products/throttle-controller-audi-tt-mk1-1998-2006",
"Holden|ZAFIRA (2000 onwards)": "/products/throttle-controller-holden-zafira-2000-onwards",
"Renault|Laguna III (2007–2015)": "/products/throttle-controller-renault-laguna-iii-2007-2015",
"Renault|Arkana (2020 onwards)": "/products/throttle-controller-renault-arkana-2020-onwards",
"Ford|Endura (2018–2019)": "/products/throttle-controller-ford-endura-2018-2019",
"Audi|RS6 (2008–2010)": "/products/throttle-controller-audi-rs6-2008-2010",
"Audi|A1 (2010–2013)": "/products/throttle-controller-audi-a1-2010-2013",
"Lexus|RX AL20 (2015–2019)": "/products/throttle-controller-lexus-rx-al20-2015-2019",
"Lexus|ES XV60 (2012–2015)": "/products/throttle-controller-lexus-es-xv60-2012-2015",
"Volkswagen|Bora (1999–2005)": "/products/throttle-controller-volkswagen-bora-1999-2005",
"Holden|Vectra C (2002–2008)": "/products/throttle-controller-holden-vectra-c-2002-2008",
"Fiat|Punto (2011–2018)": "/products/throttle-controller-fiat-punto-2011-2018",
"LDV|MIFA (2022 onwards)": "/products/throttle-controller-ldv-mifa-2022-onwards",
"Lexus|ES XV60 (2015–2018)": "/products/throttle-controller-lexus-es-xv60-2015-2018",
"Toyota|Camry XV40 (2006–2009)": "/products/throttle-controller-toyota-camry-xv40-2006-2009",
"Holden|Colorado 7 (2012-2016)": "/products/roar-4x4-throttle-controller-holden-colorado-7",
"Alfa Romeo|Brera coupe (2006 onwards)": "/products/throttle-controller-alfa-romeo-brera-coupe-2006-onwards",
"Lexus|CT200h ZWA10 (2011–2013)": "/products/throttle-controller-lexus-ct200h-zwa10-2011-2013",
"Fiat|595 (2020 onwards)": "/products/throttle-controller-fiat-595-2020-onwards",
"Lexus|Lx600 (2021 onwards)": "/products/throttle-controller-lexus-lx600-2021-onwards",
"Lexus|RX ALA10/ALH10 (5th gen) (2022 onwards)": "/products/throttle-controller-lexus-rx-ala10-alh10-2022-onwards",
"Lexus|UX ZA10 (2019 onwards)": "/products/throttle-controller-lexus-ux-za10-2019-onwards",
"Smart|FORFOUR (up to 2007)": "/products/throttle-controller-smart-forfour-up-to-2007",
"Audi|S8 D3 (2002–2010)": "/products/throttle-controller-audi-s8-d3-2002-2010",
"Alfa Romeo|159 (2006 onwards)": "/products/throttle-controller-alfa-romeo-159-2006-onwards",
"Holden|Tigra (2002–2009)": "/products/throttle-controller-holden-tigra-2002-2009",
"Alfa Romeo|SPIDER (2006 onwards)": "/products/throttle-controller-alfa-romeo-spider-2006-onwards",
"Bentley|Brooklands (2008 onwards)": "/products/throttle-controller-bentley-brooklands-2008-onwards",
"Fiat|Abarth 500 (2007–2014)": "/products/throttle-controller-fiat-abarth-500-2007-2014",
"Suzuki|KIZASHI (2013)": "/products/throttle-controller-suzuki-kizashi-2013",
"Lexus|GX550 (2024–Current)": "/products/throttle-controller-suits-lexus-gx550-2024-current-instant-throttle-response",
"Lexus|RZ XEBM15 (2023 onwards)": "/products/throttle-controller-lexus-rz-xebm15-2023-onwards",
"Lexus|LC Z100 (2018 onwards)": "/products/throttle-controller-lexus-lc-z100-2018-onwards",
"Lexus|LM AW10 (2023 onwards)": "/products/throttle-controller-lexus-lm-aw10-2023-onwards",
"Jeep|Gladiator (2020–2024)": "/products/throttle-controller-jeep-gladiator-2020-2024",
"Mitsubishi|Pajero NS/NT (2006–2011)": "/products/throttle-controller-mitsubishi-pajero-ns-nt-2006-2011",
"Mitsubishi|Pajero NW/NX (2011–2021)": "/products/throttle-controller-mitsubishi-pajero-nw-nx-2011-2021",
"Mitsubishi|Pajero Sport (Jan 2020 onwards)": "/products/throttle-controller-mitsubishi-pajero-sport-2020-onwards",
"Nissan|Navara D23 facelift (2021–2026)": "/products/throttle-controller-nissan-navara-d23-2021-2026",
"Ford|Mustang S650 (2024 onwards)": "/products/throttle-controller-ford-mustang-s650-2024-onwards",
"Ford|Mustang S550 Facelift (2018–2023)": "/products/throttle-controller-ford-mustang-s550-facelift-2018-2023",
"Ford|Mustang S550/S650 (2015 onwards)": "/products/throttle-controller-ford-mustang-2015-onwards",
"Ford|Puma (2020 onwards)": "/products/throttle-controller-ford-puma-2020-onwards",
"Mitsubishi|Pajero Sport (2015–Dec 2019)": "/products/throttle-controller-mitsubishi-pajero-sport-2015-2019",
"Jeep|Gladiator (2025 onwards)": "/products/throttle-controller-jeep-gladiator-2025-onwards",
"Toyota|C-HR AX10 facelift (2019–2024)": "/products/throttle-controller-toyota-c-hr-ax10-2019-2024",
"Nissan|Navara D23 NP300 (2015–2020)": "/products/throttle-controller-nissan-navara-d23-2015-2020",
"Lexus|NX AZ20 (2022 onwards)": "/products/throttle-controller-lexus-nx-az20-2022-onwards",
"Toyota|Kluger XU40 facelift (2010–2014)": "/products/throttle-controller-toyota-kluger-xu40-2010-2014",
"Lexus|NX AZ10 facelift (2017–2022)": "/products/throttle-controller-lexus-nx-az10-2017-2022",
"Toyota|Yaris XP210 (2020 onwards)": "/products/throttle-controller-toyota-yaris-xp210-2020-onwards",
"Toyota|Kluger XU70 (2021 onwards)": "/products/throttle-controller-toyota-kluger-xu70-2021-onwards",
"Mitsubishi|Outlander (2022 onwards)": "/products/throttle-controller-mitsubishi-outlander-2022-onwards",
"Toyota|Yaris XP130 (2011–2014)": "/products/throttle-controller-toyota-yaris-xp130-2011-2014",
"Toyota|Yaris XP130 Series III (2017–2020)": "/products/throttle-controller-toyota-yaris-xp130-series-iii-2017-2020",
"Toyota|Yaris XP130 Series II (2014–2017)": "/products/throttle-controller-toyota-yaris-xp130-series-ii-2014-2017",
"Ford|Focus SA (2018–2022)": "/products/throttle-controller-ford-focus-sa-2018-2022",
"Ford|Focus LZ (2015–2018)": "/products/throttle-controller-ford-focus-lz-2015-2018",
"Ford|Focus LW (2011–2015)": "/products/throttle-controller-ford-focus-lw-2011-2015",
"Holden|Cruze JG (2009–2011)": "/products/throttle-controller-holden-cruze-jg-2009-2011",
"Holden|Cruze JH (2011–2016)": "/products/throttle-controller-holden-cruze-jh-2011-2016",
"Toyota|Kluger XU50 Series II (2017–2020)": "/products/throttle-controller-toyota-kluger-xu50-2017-2020",
"Toyota|Kluger XU50 (2014–2017)": "/products/throttle-controller-toyota-kluger-xu50-2014-2017",
"Toyota|Camry XV70 Facelift (2021–2024)": "/products/throttle-controller-toyota-camry-xv70-2021-2024",
"Toyota|Camry XV70 (2017–2021)": "/products/throttle-controller-toyota-camry-xv70-2017-2021",
"Toyota|Camry XV50 Series II (2015–2017)": "/products/throttle-controller-toyota-camry-xv50-2015-2017",
"Toyota|Camry XV50 (2011–2015)": "/products/throttle-controller-toyota-camry-xv50-2011-2015",
"Toyota|Camry XV40 (2009–2011)": "/products/throttle-controller-toyota-camry-xv40-2009-2011",
"Chevrolet|Silverado (2023 onwards)": "/products/roar-4x4-throttle-controller-chevrolet-silverado-2023-onwards",
"Toyota|Corolla (2023 onwards)": "/products/throttle-controller-toyota-corolla-2023-onwards",
"Toyota|Corolla (2018–2022)": "/products/throttle-controller-toyota-corolla-2018-2022",
"Toyota|Corolla Sedan (2014–2019)": "/products/throttle-controller-toyota-corolla-sedan-2014-2019",
"Toyota|Corolla Hatch (2012–2018)": "/products/throttle-controller-toyota-corolla-hatch-2012-2018",
"Toyota|Corolla (2007–2012)": "/products/throttle-controller-toyota-corolla-2007-2012",
"Chevrolet|Colorado (2012-2022)": "/products/roar-4x4-throttle-controller-chevrolet-colorado",
"Mitsubishi|Express (2020 onwards)": "/products/roar-4x4-throttle-controller-mitsubishi-express",
"Ford|Transit (2013 onwards)": "/products/roar-4x4-throttle-controller-ford-transit",
"Volkswagen|Transporter T5–T6.1 (2009–2025)": "/products/roar-4x4-throttle-controller-volkswagen-transporter",
"Nissan|Juke (2011 onwards)": "/products/roar-4x4-throttle-controller-nissan-juke",
"Nissan|Qashqai (2006 onwards)": "/products/roar-4x4-throttle-controller-nissan-qashqai",
"Nissan|Dualis (2006-2014)": "/products/roar-4x4-throttle-controller-nissan-dualis",
"LDV|V80 (2014 onwards)": "/products/roar-4x4-throttle-controller-ldv-v80",
"LDV|G10 (2014 onwards)": "/products/roar-4x4-throttle-controller-ldv-g10",
"Jeep|Renegade (2014 onwards)": "/products/roar-4x4-throttle-controller-jeep-renegade",
"Jeep|Compass (2017 onwards)": "/products/roar-4x4-throttle-controller-jeep-compass",
"Toyota|LandCruiser 100 Series V8 (Plug 831)": "/products/roar-4x4-throttle-controller-toyota-landcruiser-100-v8-831",
"Lexus|GX550H (2024 onwards)": "/products/roar-4x4-throttle-controller-lexus-gx550h",
"Lexus|LX500D (2022 onwards)": "/products/roar-4x4-throttle-controller-lexus-lx500d",
"Haval|H8 (2013 onwards)": "/products/roar-4x4-throttle-controller-haval-h8",
"Haval|H6 (2011 onwards)": "/products/roar-4x4-throttle-controller-haval-h6",
"Toyota|LandCruiser 100 Series (5-pin pedal)": "/products/roar-4x4-throttle-controller-toyota-landcruiser-100-5pin-t63",
"Toyota|Hilux (2000–2004, 5-pin pedal)": "/products/roar-4x4-throttle-controller-toyota-hilux-2000-2004-t63",
"Multi-fit (by plug)|Plug T63": "/products/roar-4x4-throttle-controller-plug-t63",
"Multi-fit (by plug)|Plug 831": "/products/roar-4x4-throttle-controller-plug-831",
"Porsche|Cayenne (2002 onwards)": "/products/roar-4x4-throttle-controller-porsche-cayenne",
"Nissan|X-Trail T32 (2014 onwards)": "/products/roar-4x4-throttle-controller-nissan-x-trail-t32",
"Mitsubishi|Pajero Sport (2015 onwards)": "/products/roar-4x4-throttle-controller-mitsubishi-pajero-sport",
"Mitsubishi|Pajero NX (2014-2021)": "/products/roar-4x4-throttle-controller-mitsubishi-pajero-nx",
"Mitsubishi|Outlander (2012 onwards)": "/products/roar-4x4-throttle-controller-mitsubishi-outlander",
"Mercedes-Benz|X-Class (2018-2020)": "/products/roar-4x4-throttle-controller-mercedes-benz-x-class",
"Lexus|LX570 (2008 onwards)": "/products/roar-4x4-throttle-controller-lexus-lx570",
"Land Rover|Discovery 5 (2017 onwards)": "/products/roar-4x4-throttle-controller-land-rover-discovery-5",
"Land Rover|Discovery 4 (2009-2016)": "/products/roar-4x4-throttle-controller-land-rover-discovery-4",
"Land Rover|Defender 130 (2022 onwards)": "/products/roar-4x4-throttle-controller-land-rover-defender-130",
"Land Rover|Defender (2020 onwards)": "/products/roar-4x4-throttle-controller-land-rover-defender",
"Hino|300 Series (2011 onwards)": "/products/roar-4x4-throttle-controller-hino-300-series",
"Holden|Colorado RG (2012-2020)": "/products/roar-4x4-throttle-controller-holden-colorado-rg",
"Toyota|LandCruiser 100 (2002-2007)": "/products/roar-4x4-throttle-controller-toyota-landcruiser-100",
"Ford|F-150 (2015 onwards)": "/products/roar-4x4-throttle-controller-ford-f-150",
"Jeep|Gladiator (2020 onwards)": "/products/roar-4x4-throttle-controller-jeep-gladiator",
"Jeep|Cherokee KL (2014 onwards)": "/products/roar-4x4-throttle-controller-jeep-cherokee-kl",
"Haval|H9 (2014 Onwards)": "/products/roar-4x4-throttle-controller-haval-h9",
"Volkswagen|Touareg": "/products/roar-4x4-throttle-controller-volkswagen-touareg",
"Toyota|Sequoia": "/products/roar-4x4-throttle-controller-toyota-sequoia",
"Toyota|Highlander": "/products/roar-4x4-throttle-controller-toyota-highlander",
"Toyota|Hiace H300": "/products/roar-4x4-throttle-controller-toyota-hiace-h300",
"Toyota|Hiace H200": "/products/roar-4x4-throttle-controller-toyota-hiace-h200",
"Toyota|Granvia": "/products/roar-4x4-throttle-controller-toyota-granvia",
"Toyota|4Runner N280": "/products/roar-4x4-throttle-controller-toyota-4runner-n280",
"Toyota|4Runner N210": "/products/roar-4x4-throttle-controller-toyota-4runner-n210",
"Suzuki|Vitara": "/products/roar-4x4-throttle-controller-suzuki-vitara",
"Suzuki|Grand Vitara": "/products/roar-4x4-throttle-controller-suzuki-grand-vitara",
"Nissan|Xterra": "/products/roar-4x4-throttle-controller-nissan-xterra",
"Nissan|Titan": "/products/roar-4x4-throttle-controller-nissan-titan",
"Nissan|Terra": "/products/roar-4x4-throttle-controller-nissan-terra",
"Nissan|Murano": "/products/roar-4x4-throttle-controller-nissan-murano",
"Mitsubishi|Xpander": "/products/roar-4x4-throttle-controller-mitsubishi-xpander",
"Mitsubishi|Montero": "/products/roar-4x4-throttle-controller-mitsubishi-montero",
"Mitsubishi|ASX": "/products/roar-4x4-throttle-controller-mitsubishi-asx",
"Lexus|GX470": "/products/roar-4x4-throttle-controller-lexus-gx470",
"Land Rover|Range Rover Velar": "/products/roar-4x4-throttle-controller-land-rover-range-rover-velar",
"Land Rover|Range Rover Sport": "/products/roar-4x4-throttle-controller-land-rover-range-rover-sport",
"Land Rover|Range Rover": "/products/roar-4x4-throttle-controller-land-rover-range-rover",
"Land Rover|Evoque": "/products/roar-4x4-throttle-controller-land-rover-evoque",
"Land Rover|Discovery Sport": "/products/roar-4x4-throttle-controller-land-rover-discovery-sport",
"Hummer|H3": "/products/roar-4x4-throttle-controller-hummer-h3",
"Holden|Trailblazer": "/products/roar-4x4-throttle-controller-holden-trailblazer",
"GMC|Canyon": "/products/roar-4x4-throttle-controller-gmc-canyon",
"Ford|Maverick": "/products/roar-4x4-throttle-controller-ford-maverick",
"Ford|F350": "/products/roar-4x4-throttle-controller-ford-f350",
"Ford|F250": "/products/roar-4x4-throttle-controller-ford-f250",
"Ford|Explorer": "/products/roar-4x4-throttle-controller-ford-explorer",
"Ford|Bronco": "/products/roar-4x4-throttle-controller-ford-bronco",
"Dodge|RAM 1500 TRX": "/products/roar-4x4-throttle-controller-dodge-ram-1500-trx",
"Dodge|RAM 1500": "/products/roar-4x4-throttle-controller-dodge-ram-1500",
"Chevrolet|Silverado (2019–2022)": "/products/roar-4x4-throttle-controller-chevrolet-silverado-2019-2022",
"Toyota|RAV4": "/products/roar-4x4-throttle-controller-toyota-rav4",
"Ford|F150": "/products/roar-4x4-throttle-controller-ford-f150",
"Toyota|LandCruiser 76/79 Combo Kit 2 (2022 onwards)": "/products/roar-4x4-combo-toyota-landcruiser-76-79-kit-2",
"Toyota|LandCruiser 76/79 Combo Kit 1 (2022 onwards)": "/products/roar-4x4-combo-toyota-landcruiser-76-79-kit-1",
"Nissan|Patrol GU S4+ Combo Kit 2 (2004-2016)": "/products/roar-4x4-combo-nissan-patrol-gu-s4-kit-2",
"Nissan|Patrol GU S4+ Combo Kit 1 (2004-2016)": "/products/roar-4x4-combo-nissan-patrol-gu-s4-kit-1",
"Mitsubishi|Pajero Sport QE/QF Combo Kit 2 (2015 onwards)": "/products/roar-4x4-combo-mitsubishi-pajero-sport-qe-qf-kit-2",
"Mitsubishi|Pajero Sport QE/QF Combo Kit 1 (2015 onwards)": "/products/roar-4x4-combo-mitsubishi-pajero-sport-qe-qf-kit-1",
"Mitsubishi|Pajero V90 Combo Kit 2 (2006-2018)": "/products/roar-4x4-combo-mitsubishi-pajero-v90-kit-2",
"Mitsubishi|Pajero V90 Combo Kit 1 (2006-2018)": "/products/roar-4x4-combo-mitsubishi-pajero-v90-kit-1",
"Ford|Next Gen Ranger Combo Kit 2 (2022 onwards)": "/products/roar-4x4-combo-ford-next-gen-ranger-kit-2",
"Mercedes-Benz|X-Class (X220D, X250D, X350D)": "/products/throttle-controller-suits-mercedes-x-class-x220d-x250d-x350d-instant-pedal-response",
"Dodge|RAM": "/products/throttle-controller-suits-dodge-ram-ram-1500-trx-and-promaster-instant-pedal-response",
"Mitsubishi|Pajero V80 (2006–Current)": "/products/mitsubishi-pajero-v80-2006-current-throttle-controller-plug-and-play-instant-pedal-response"
};
  Object.keys(EXTRA).forEach(function (k) { if (!CANONICAL[k]) CANONICAL[k] = EXTRA[k]; });

  window.ROAR_FINDER = { canonical: CANONICAL, fallback: FALLBACK, makeTc: MAKE_TC };

  function sanitize(url) {
    if (!url) return '/collections/throttle-controllers';
    if (url.indexOf('/products/') === 0) return url;
    if (/-2$/.test(url) || /-3$/.test(url) || /-4$/.test(url)) {
      return '/collections/throttle-controllers';
    }
    var handle = url.replace('/collections/', '');
    if (FALLBACK[handle]) return FALLBACK[handle];
    return url;
  }

  function urlFor(make, model) {
    var key = make + '|' + model;
    if (CANONICAL[key]) return sanitize(CANONICAL[key]);
    if (MAKE_TC[make]) return MAKE_TC[make];
    return '/collections/throttle-controllers';
  }

  function go(make, model) {
    window.location = urlFor(make, model);
  }

  var MODELS = {};
  Object.keys(CANONICAL).forEach(function (key) {
    var parts = key.split('|');
    var make = parts[0];
    var model = parts[1];
    if (!MODELS[make]) MODELS[make] = [];
    if (MODELS[make].indexOf(model) === -1) MODELS[make].push(model);
  });

  document.querySelectorAll('[data-roar-finder]').forEach(function (root) {
    var makeSel = root.querySelector('[data-roar-make]');
    var modelSel = root.querySelector('[data-roar-model]');
    var form = root.querySelector('[data-roar-finder-form]');
    var err = root.querySelector('[data-roar-finder-err]');
    var type = root.querySelector('[data-roar-typeahead]');
    var suggest = root.querySelector('[data-roar-suggest]');

    Object.keys(MODELS).sort().forEach(function (m) {
      var o = document.createElement('option');
      o.value = m;
      o.textContent = m;
      makeSel.appendChild(o);
    });

    makeSel.addEventListener('change', function () {
      modelSel.innerHTML = '<option value="">Select model</option>';
      modelSel.disabled = !makeSel.value;
      (MODELS[makeSel.value] || []).forEach(function (model) {
        var o = document.createElement('option');
        o.value = model;
        o.textContent = model;
        modelSel.appendChild(o);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!makeSel.value || !modelSel.value) {
        err.hidden = false;
        return;
      }
      err.hidden = true;
      go(makeSel.value, modelSel.value);
    });

    function allKeys() {
      return Object.keys(CANONICAL).map(function (k) {
        var p = k.split('|');
        return { key: k, make: p[0], model: p[1], label: p[0] + ' ' + p[1] };
      });
    }

    if (type && suggest) {
      type.addEventListener('input', function () {
        var q = type.value.trim().toLowerCase();
        suggest.innerHTML = '';
        if (q.length < 2) { suggest.hidden = true; return; }
        var hits = allKeys().filter(function (row) { return row.label.toLowerCase().indexOf(q) !== -1; }).slice(0, 8);
        hits.forEach(function (row) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = row.label;
          b.addEventListener('click', function () { go(row.make, row.model); });
          li.appendChild(b);
          suggest.appendChild(li);
        });
        suggest.hidden = hits.length === 0;
      });
    }
  });
})();
